import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useLanguage } from '../context/LanguageContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          navigate('/register?error=auth_error');
          return;
        }

        if (data.session) {
          // Successfully authenticated, redirect to home or previous page
          const redirectTo = sessionStorage.getItem('redirectAfterAuth') || '/';
          sessionStorage.removeItem('redirectAfterAuth');
          navigate(redirectTo);
        } else {
          // No session, redirect to login
          navigate('/register');
        }
      } catch (error) {
        navigate('/register?error=unexpected_error');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="flex flex-col items-center">
            <LoadingSpinner />
            <h2 className="mt-4 text-lg font-medium text-gray-900">
              {t('auth.processing')}
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              {t('auth.completingLogin')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback; 